import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

// Marks a starter name the user hasn't changed yet. A label only: the pencil or field next to it renames.
const DefaultNameTag: React.FC = () => (
	<Tooltip title="Rename it so exports and reports make sense to others">
		<Chip
			label="Default name"
			size="small"
			sx={{
				height: 22,
				bgcolor: '#ECEDEF',
				color: '#556670',
				fontFamily: 'Jost, sans-serif',
				fontSize: 13,
				flexShrink: 0,
			}}
		/>
	</Tooltip>
);

export default DefaultNameTag;
